import React, { useCallback } from 'react';
import css from './styles.module.scss';
import { Grid, Switch, Typography } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import { StepControls } from '~/common/step-controls';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { INewMoneyStepOneFormInputs } from '~/models/money/new-money/formInputs';
import classNames from 'classnames';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';
import { newDealFormNextStep } from '~/features/dashboard/store/actions';
import { DatePickerController } from '~/features/dashboard/components/date-picker-controller';

interface Step_2Props {
    prevStep: () => void;
}

export const Step_2: React.FC<Step_2Props> = ({ prevStep }) => {
    // const match = useRouteMatch<{ creatorId: string }>();
    // const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    // const newDealState = useSelector(selectNewDeal);
    const dispatch = useThunkDispatch();
    // const { selectedDateFormat } = useDateFormat();
    // const [periodCovers, setPeriodCovers] = React.useState<DateRange<Date>>([null, null]);

    const { handleSubmit, register, control, setValue, errors } = useForm<INewMoneyStepOneFormInputs>({
        defaultValues: {
            isPayable: false,
            reference: '',
            usersRef: '',
            internalReference: '',
            isBilling: false,
        },
    });

    const onSubmit = useCallback(
        (data: INewMoneyStepOneFormInputs) => {
            // dispatch(createNewDealStepOneThunk({ ...data, creatorId, }));
            dispatch(newDealFormNextStep());
        },
        [dispatch]
    );

    return (
        <div className={css.module}>
            <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography align={'left'} variant={'h6'} className={classNames(css.bold, css.title)}>
                            test - test the Statement Received
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <label className="customlabel bold">Does statement Show an amount payable?</label>
                        <div className={'inputcustom-outer switch-custom-outer'} style={{ display: 'flex', alignItems: 'center' }}>
                            <span>No</span>
                            <Controller
                                name="isPayable"
                                control={control}
                                render={props => {
                                    return (
                                        <Switch
                                            // size="small"
                                            id="e-book-switch1"
                                            type="checkbox"
                                            name="isPayable"
                                            onChange={e => setValue('payable', e.target.checked)}
                                            // inputRef={register}
                                            value={props.value}
                                            checked={props.value}
                                        />
                                    );
                                }}
                            />
                            <span> Yes</span>
                        </div>
                    </Grid>
                    <Grid item xs={6} />
                    <Grid item xs={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <label className="customlabel bold">Enter details</label>
                        <div className={'inputcustom-outer switch-custom-outer'} style={{ display: 'flex', alignItems: 'center' }}>
                            <label style={{ width: '50px' }} className="labelMoney">Paid?</label>
                            <span>No</span>
                            <Controller
                                name="isPayable"
                                control={control}
                                render={props => {
                                    return (
                                        <Switch
                                            // size="small"
                                            id="e-book-switch1"
                                            type="checkbox"
                                            name="isPayable"
                                            onChange={e => setValue('payable', e.target.checked)}
                                            // inputRef={register}
                                            value={props.value}
                                            checked={props.value}
                                        />
                                    );
                                }}
                            />
                            <span> Yes</span>
                        </div>
                    </Grid>
                    <Grid item xs={2} />
                    <Grid item xs={4} style={{ paddingRight: '25px' }} >
                        <TextInput
                            className={css.textInput}
                            label={'B/F Balance'}
                            name={'usersRef'}
                            register={register}
                            fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.customDatePicker} style={{ paddingLeft: '25px' }}>
                        <DatePickerController name="releaseDate" control={control} label="Date of Payment" row />
                    </Grid>
                    <Grid item xs={2}>
                        <TextInput
                            className={css.textInput}
                            label={'Amount Due'}
                            name={'usersRef'}
                            register={register}
                            fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextInput
                            className={css.textInput}
                            placeholder={'USD $'}
                            label={'Currency'}
                            name={'usersRef'}
                            register={register}
                            fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={1} />
                    <Grid item xs={4} style={{ paddingRight: '25px' }}>
                        <TextInput
                            className={css.textInput}
                            label={'Converted Amount'}
                            name={'usersRef'}
                            register={register}
                            fieldError={errors.usersRef}
                        />
                        <TextInput
                            className={css.textInput}
                            label={'C/F Balance'}
                            name={'usersRef'}
                            register={register}
                            fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <label className="customlabel bold">Does the sender required an invoice to be send?</label>
                        <div className={'inputcustom-outer switch-custom-outer'} style={{ display: 'flex', alignItems: 'center' }}>
                            <span>No</span>
                            <Controller
                                name="isBilling"
                                control={control}
                                render={props => {
                                    return (
                                        <Switch
                                            // size="small"
                                            id="e-book-switch1"
                                            type="checkbox"
                                            name="isBilling"
                                            onChange={e => setValue('isBilling', e.target.checked)}
                                            // inputRef={register}
                                            value={props.value}
                                            checked={props.value}
                                        />
                                    );
                                }}
                            />
                            <span> Yes</span>
                        </div>
                    </Grid>
                </Grid>
                <StepControls onPrevClick={prevStep} className={css.nextButton} />
            </form>
        </div>
    );
};
